var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.69231 16H0.335664V5.93007H3.69231V16ZM2.01399 4.02797C0.895105 4.02797 0 3.13287 0 2.01399C0 0.895105 0.895105 0 2.01399 0C3.13287 0 4.02797 0.895105 4.02797 2.01399C4.02797 3.13287 3.13287 4.02797 2.01399 4.02797ZM16 16H12.6434V10.0699C12.6434 9.17483 11.8601 8.39161 10.965 8.39161C10.0699 8.39161 9.28671 9.17483 9.28671 10.0699V16H5.93007V5.93007H9.28671V7.27273C9.84615 6.37762 11.0769 5.70629 12.0839 5.70629C14.2098 5.70629 16 7.4965 16 9.62238V16Z"}));
}

Linkedin.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"currentColor"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
